export default __webpack_public_path__ + "img/8758dbf3ebc88387f3132b135056e979.png";